import { render, staticRenderFns } from "./batchLaunch.vue?vue&type=template&id=542c974e&scoped=true&"
import script from "./batchLaunch.vue?vue&type=script&lang=js&"
export * from "./batchLaunch.vue?vue&type=script&lang=js&"
import style0 from "./batchLaunch.vue?vue&type=style&index=0&id=542c974e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542c974e",
  null
  
)

export default component.exports